import { useState, useEffect } from "react";

const useMedia = (query: string) => {
  const [matches, setMatches] = useState(window.matchMedia(query).matches);

  const updateMedia = () => {
    setMatches(window.matchMedia(query).matches);
  };

  useEffect(() => {
    window.addEventListener("resize", updateMedia);

    return () => window.removeEventListener("resize", updateMedia);
  }, [query, matches]);

  return matches;
};

export default useMedia;
